import AuthLayout from "~/components/AuthLayout";
import { useSearchParams } from "react-router-dom";

export default function LoginRoute() {
  const [sq] = useSearchParams();

  return (
    <AuthLayout
      showCounter={true}
      title="Create a BuildJet account"
      description="Create a BuildJet account to speed up your GitHub Actions."
      action="Sign up"
      cta="Login"
      ctaHref={`/login?${sq.toString()}`}
    />
  );
}
